const rings = [
  {
    id: 1,
    name: "Elegant Gold Band Ring",
    image: "images/ring29.JPG",
    price: 150,
    alt: "Elegant Gold Band Ring",
  },
  {
    id: 2,
    name: "Classic Solitaire Gold Ring",
    image: "images/ring30.JPG",
    price: 200,
    alt: "Classic Solitaire Gold Ring",
  },
  {
    id: 3,
    name: "Vintage Gold Filigree Ring",
    image: "images/ring31.JPG",
    price: 180,
    alt: "Vintage Gold Filigree Ring",
  },
  {
    id: 4,
    name: "Minimalist Gold Knot Ring",
    image: "images/ring21.JPG",
    price: 140,
    alt: "Minimalist Gold Knot Ring",
  },
  {
    id: 5,
    name: "Twisted Gold Rope Ring",
    image: "images/ring22.jpg",
    price: 160,
    alt: "Twisted Gold Rope Ring",
  },
  {
    id: 6,
    name: "Gold Infinity Symbol Ring",
    image: "images/ring23.JPG",
    price: 170,
    alt: "Gold Infinity Symbol Ring",
  },
  {
    id: 7,
    name: "Gold Leaf Design Ring",
    image: "images/ring32.JPG",
    price: 155,
    alt: "Gold Leaf Design Ring",
  },
  {
    id: 8,
    name: "Bold Statement Gold Ring",
    image: "images/ring33.JPG",
    price: 210,
    alt: "Bold Statement Gold Ring",
  },
  {
    id: 9,
    name: "Intricate Gold Lace Ring",
    image: "images/ring20.JPG",
    price: 190,
    alt: "Intricate Gold Lace Ring",
  },
  {
    id: 10,
    name: "Gold Floral Cluster Ring",
    image: "images/ring24.JPG",
    price: 220,
    alt: "Gold Floral Cluster Ring",
  },
  {
    id: 11,
    name: "Gold Diamond Accent Ring",
    image: "images/ring25.JPG",
    price: 250,
    alt: "Gold Diamond Accent Ring",
  },
  {
    id: 12,
    name: "Gold Heart Design Ring",
    image: "images/ring26.JPG",
    price: 160,
    alt: "Gold Heart Design Ring",
  },
  {
    id: 13,
    name: "Gold Geometric Band Ring",
    image: "images/ring18.JPG",
    price: 175,
    alt: "Gold Geometric Band Ring",
  },
  {
    id: 14,
    name: "Gold Stackable Band Rings",
    image: "images/ring19.JPG",
    price: 130,
    alt: "Gold Stackable Band Rings",
  },
  {
    id: 15,
    name: "Gold Cross Symbol Ring",
    image: "images/ring11.jpg",
    price: 165,
    alt: "Gold Cross Symbol Ring",
  },
  {
    id: 16,
    name: "Gold Celtic Knot Ring",
    image: "images/ring12.jpg",
    price: 180,
    alt: "Gold Celtic Knot Ring",
  },
  {
    id: 17,
    name: "Gold Beaded Texture Ring",
    image: "images/ring13.JPG",
    price: 145,
    alt: "Gold Beaded Texture Ring",
  },
  {
    id: 18,
    name: "Gold Pearl Accent Ring",
    image: "images/ring14.jpg",
    price: 195,
    alt: "Gold Pearl Accent Ring",
  },
  {
    id: 19,
    name: "Gold Wavy Design Ring",
    image: "images/ring15alt.JPG",
    price: 170,
    alt: "Gold Wavy Design Ring",
  },
  {
    id: 20,
    name: "Gold Hollow Circle Ring",
    image: "images/ring16.JPG",
    price: 135,
    alt: "Gold Hollow Circle Ring",
  },
  {
    id: 21,
    name: "Gold Bar Design Ring",
    image: "images/ring10.JPG",
    price: 140,
    alt: "Gold Bar Design Ring",
  },
  {
    id: 22,
    name: "Gold Mesh Texture Ring",
    image: "images/ring9.jpg",
    price: 185,
    alt: "Gold Mesh Texture Ring",
  },
  {
    id: 23,
    name: "Gold Curved Line Ring",
    image: "images/ring-b1.jpg",
    price: 160,
    alt: "Gold Curved Line Ring",
  },
  {
    id: 24,
    name: "Gold Butterfly Design Ring",
    image: "images/ring27alt.JPG",
    price: 175,
    alt: "Gold Butterfly Design Ring",
  },
  {
    id: 25,
    name: "Gold Arrow Band Ring",
    image: "images/ring28.JPG",
    price: 150,
    alt: "Gold Arrow Band Ring",
  },
  {
    id: 26,
    name: "Gold Hexagon Ring",
    image: "images/ring35.JPG",
    price: 170,
    alt: "Gold Hexagon Ring",
  },
  {
    id: 27,
    name: "Gold Moon and Star Ring",
    image: "images/ring36.JPG",
    price: 190,
    alt: "Gold Moon and Star Ring",
  },
  {
    id: 28,
    name: "Gold Chevron Stacking Ring",
    image: "images/ring37.JPG",
    price: 140,
    alt: "Gold Chevron Stacking Ring",
  },
  {
    id: 29,
    name: "Gold Interlocking Rings",
    image: "images/ring34.JPG",
    price: 165,
    alt: "Gold Interlocking Rings",
  },
  {
    id: 30,
    name: "Gold Spiral Ring",
    image: "images/ring2.JPG",
    price: 145,
    alt: "Gold Spiral Ring",
  },
  {
    id: 31,
    name: "Gold Double Band Ring",
    image: "images/ring3.JPG",
    price: 180,
    alt: "Gold Double Band Ring",
  },
  {
    id: 32,
    name: "Gold Open Circle Ring",
    image: "images/ring4.JPG",
    price: 160,
    alt: "Gold Open Circle Ring",
  },
  {
    id: 33,
    name: "Gold Studded Band Ring",
    image: "images/ring5.JPG",
    price: 170,
    alt: "Gold Studded Band Ring",
  },
  {
    id: 34,
    name: "Gold Adjustable Knot Ring",
    image: "images/ring6.JPG",
    price: 150,
    alt: "Gold Adjustable Knot Ring",
  },
  {
    id: 35,
    name: "Gold Split Shank Ring",
    image: "images/ring8.JPG",
    price: 185,
    alt: "Gold Split Shank Ring",
  },
  {
    id: 36,
    name: "Gold Square Band Ring",
    image: "images/ring1.JPG",
    price: 160,
    alt: "Gold Square Band Ring",
  },
  {
    id: 37,
    name: "Gold Hammered Texture Ring",
    image: "images/ring-group1.jpg",
    price: 170,
    alt: "Gold Hammered Texture Ring",
  },
];

export default rings;
